import { createSelector } from 'reselect'

import { RootState } from '../RootState'

export const getTipsList = createSelector(
  (state: RootState) => state.tips.entities,
  (tips) => Object.values(tips),
)
